import { SvgProps } from "../Form";

export const OnHoldIcon = (props: SvgProps) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0_7234_2095)">
      <path
        d="M7 0C3.14008 0 0 3.14008 0 7C0 10.8599 3.14008 14 7 14C10.8599 14 14 10.8599 14 7C14 3.14008 10.8599 0 7 0ZM7 12.8333C3.7835 12.8333 1.16667 10.2165 1.16667 7C1.16667 3.7835 3.7835 1.16667 7 1.16667C10.2165 1.16667 12.8333 3.7835 12.8333 7C12.8333 10.2165 10.2165 12.8333 7 12.8333ZM6.41667 5.25V8.75C6.41667 9.072 6.15533 9.33333 5.83333 9.33333C5.51133 9.33333 5.25 9.072 5.25 8.75V5.25C5.25 4.928 5.51133 4.66667 5.83333 4.66667C6.15533 4.66667 6.41667 4.928 6.41667 5.25ZM8.75 5.25V8.75C8.75 9.072 8.48867 9.33333 8.16667 9.33333C7.84467 9.33333 7.58333 9.072 7.58333 8.75V5.25C7.58333 4.928 7.84467 4.66667 8.16667 4.66667C8.48867 4.66667 8.75 4.928 8.75 5.25Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_7234_2095">
        <rect width="14" height="14" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);
